import React, { useState } from 'react';
import { Button, Card, CardHeader, CardBody, Col, Row, Input, CardFooter } from 'reactstrap';
import { sentenceCase } from 'change-case';
import { FormikProps } from 'formik';

import { IEmailTemplates } from 'types';
import { IEmailTemplatesPage } from '../EmailTemplatesDisplayWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

export const EmailTemplatesDisplay = (props: IEmailTemplates & FormikProps<IEmailTemplates> & IEmailTemplatesPage) => {
  const { dirty, isSending, isSubmitting, onPost, globalConfigs, auth0OrganizationInfo, templates } = props;

  const [testEmail, setTestEmail] = useState('');

  const extractTextFromHTML = (htmlString: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
  };

  const noMetaData = () => {
    return (
      <div style={{ color: '#D0342C' }}>
        <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
        <span>No metadata set</span>
      </div>
    );
  };

  const handleSendTextEmail = (type: number) => {
    if (onPost) {
      onPost({
        sendTo: testEmail,
        type: type,
      });
    }
  };

  return (
    <>
      <Card className="mb-3">
        <CardHeader tag="h5">Global email tokens</CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{PortalName}}`}</Col>
            <Col xs={9}>{globalConfigs.portalName}</Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{EmailClosing}}`}</Col>
            <Col xs={9}>{globalConfigs.emailClosing}</Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{CustomerServiceMessage}}`}</Col>
            <Col xs={9}>{extractTextFromHTML(globalConfigs.customerServiceMessage)}</Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{TextContrastColor}}`}</Col>
            <Col xs={9}>{globalConfigs.textContrastColor}</Col>
          </Row>
          <Row>
            <Col xs={3} className="font-weight-bold">{`{{EmailFromName}}`}</Col>
            <Col xs={9}>{globalConfigs.autoMailerFromName}</Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-3">
        <CardHeader tag="h5">Auth0 objects</CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{primary}}`}</Col>
            <Col xs={9}>{auth0OrganizationInfo.branding.colors.primary}</Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{text_contrast_color}}`}</Col>
            <Col xs={9}>
              {auth0OrganizationInfo.metadata.text_contrast_color
                ? auth0OrganizationInfo.metadata.text_contrast_color
                : noMetaData()}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{logo_url}}`}</Col>
            <Col xs={9}>
              <Row style={{ marginLeft: '0' }}>{auth0OrganizationInfo.branding.logo_url}</Row>
              <Row className="my-2">
                <img
                  src={auth0OrganizationInfo.branding.logo_url}
                  alt="Branding logo"
                  style={{ width: '8rem', height: 'auto' }}
                />
              </Row>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{display_name}}`}</Col>
            <Col xs={9}>{auth0OrganizationInfo.display_name}</Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{client_portal_name}}`}</Col>
            <Col xs={9}>
              {auth0OrganizationInfo.metadata.client_portal_name
                ? auth0OrganizationInfo.metadata.client_portal_name
                : noMetaData()}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3} className="font-weight-bold">{`{{customer_service}}`}</Col>
            <Col xs={9}>
              {auth0OrganizationInfo.metadata.customer_service
                ? auth0OrganizationInfo.metadata.customer_service
                : noMetaData()}
            </Col>
          </Row>
          <Row>
            <Col xs={3} className="font-weight-bold">{`{{email_closing}}`}</Col>
            <Col xs={9}>
              {auth0OrganizationInfo.metadata.email_closing
                ? auth0OrganizationInfo.metadata.email_closing
                : noMetaData()}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div>
        {Object.entries(templates).map(([name, template]) => {
          const { type } = template;
          return (
            <Card className="mb-3" key={type}>
              <CardHeader tag="h5">{sentenceCase(name)}</CardHeader>
              <CardBody className="p-3">
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Subject
                  </Col>
                  <Col md={10}>
                    <div>{template.subject}</div>
                  </Col>
                </Row>
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Banner Text
                  </Col>
                  <Col md={10}>
                    <div>{template.banner}</div>
                  </Col>
                </Row>
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Body Text
                  </Col>
                  <Col md={10}>
                    <div style={{ width: '600px' }} dangerouslySetInnerHTML={{ __html: template.body }} />
                  </Col>
                </Row>
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Button Text
                  </Col>
                  <Col md={10}>
                    <div>{template.button}</div>
                  </Col>
                </Row>
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Button Link
                  </Col>
                  <Col md={10}>
                    <div>{template.buttonLinkUrl}</div>
                  </Col>
                </Row>
                <Row className="py-3 m-0" style={{ borderBottom: '1px solid #CAD0D6' }}>
                  <Col className="pl-0 font-weight-bold" md={2}>
                    Tokens
                  </Col>
                  <Col md={10}>
                    <div className="d-flex" style={{ flexWrap: 'wrap', gap: '.5rem' }}>
                      {template.tokens.map((token: string) => (
                        <div
                          key={token}
                          className="mr-2 font-weight-bold"
                          style={{
                            backgroundColor: '#29A2B7',
                            color: '#fff',
                            padding: '.5rem .75rem',
                            borderRadius: '4px',
                          }}
                        >
                          {token}
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <div className="input-group">
                  <Input
                    disabled={isSubmitting}
                    placeholder="Enter an email address to send a test"
                    onKeyDown={function (e) {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        onPost &&
                          onPost({
                            sendTo: testEmail,
                            type,
                          });
                      }
                    }}
                    type="text"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.currentTarget.value)}
                  />
                  <div className="input-group-append">
                    <Button
                      color="primary"
                      disabled={dirty || testEmail === '' || isSending}
                      onClick={() => handleSendTextEmail(type)}
                    >
                      {isSending ? 'Sending ...' : 'Send Test'}
                    </Button>
                  </div>
                </div>
              </CardFooter>
            </Card>
          );
        })}
      </div>
    </>
  );
};
